import React from 'react';

import { BadgeGroup, BadgeGroupItem, Inline, Typography } from '@crossnokaye/ux-common';

export type GroupBy = 'equipment' | 'setting';

interface GroupByToggleProps {
  value: GroupBy;
  onChange: (value: GroupBy) => void;
}

export const GroupByToggle = ({ value, onChange }: GroupByToggleProps): React.ReactElement => {
  const handleSelectionChange = (items: Array<{ id: string }>) => {
    if (items.length > 0) {
      onChange(items[0].id as GroupBy);
    }
  };

  return (
    <Inline gap="sm" className="items-center" data-component="GroupByToggle">
      <Typography variant="body" className="text-xs uppercase tracking-wider">
        Group By:
      </Typography>
      <BadgeGroup selectedIds={[value]} onSelectionChange={handleSelectionChange}>
        <BadgeGroupItem id="equipment">Equipment</BadgeGroupItem>
        <BadgeGroupItem id="setting">Settings</BadgeGroupItem>
      </BadgeGroup>
    </Inline>
  );
};
